import { createSelector } from '@reduxjs/toolkit';
import { User } from '../@types/user';
import { RootState } from '../rootReducer';

const userSelector = (state: RootState): User => state.user;

const selectUserName = createSelector(
  [userSelector],
  (user: User) => `${user.name} ${user.surname}`,
);

const selectUserInitials = createSelector(
  [userSelector],
  (user: User) => {
    const first = user.name?.charAt(0) ?? '';
    const last = user.surname?.charAt(0) ?? '';
    return (first + last).toUpperCase() || '?';
  },
);

const getUserId = createSelector(
  [userSelector],
  (user: User) => user.id,
);

const getRole = createSelector([userSelector], (user: User) => user.role);

const getAuthorizations = createSelector([userSelector], (user: User) => user.authorizations);

export {
  selectUserName,
  selectUserInitials,
  getRole,
  getUserId,
  getAuthorizations
};
